export default {
  TITLE: "Cash Register Readings Report",
  TOTAL_AMOUNT: "Total Amount",
  TOTAL_TRANSACTIONS: "Total Transactions",
  AVERAGE_PER_TRANSACTION: "Avg. per Transaction",
  TOTAL_READINGS: "Total Readings",
  TOTALS_OVER_TIME: "Totals Over Time",
  PAYMENT_BREAKDOWN: "Payment Type Breakdown",
  REGISTER_COMPARISON: "Cash Register Comparison",
  TRANSACTION_TRENDS: "Transaction Trends",
};
